import './backToTop.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};

export default function BackToTop() {
    return (
        <>
            <div>
                <span className="back-to-top" onClick={() => scrollToTop()}><FontAwesomeIcon icon={faArrowUp} /> Back to top</span>
            </div>
        </>
    );
}